import {Header} from "../components/template/header";
import {Sidenav} from "../components/template/sidenav";
import {Outlet, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {AuthRedirectAdmins, AuthRedirectParents, PostJSON} from "../components/api/webservice";
import {HideMainLoading} from "../components/template/architecture";
import {ShowConnectionFailed} from "../components/template/connection-failed";
import {
    ThinAbsentIcon, ThinAccountCircleIcon,
    ThinAdvertisingIcon, ThinBuildingIcon,
    ThinChart2Icon, ThinConsentIcon, ThinConsultIcon, ThinCreditScoreIcon,
    ThinDashboardIcon, ThinEducationIcon,
    ThinGlobeIcon,
    ThinnerPeopleIcon,
    ThinnerSMSIcon, ThinSettingIcon,
    ThinStoreIcon, ThinTaskIcon
} from "../components/icons/material-icons";
import {Apis} from "../components/api/url";

export const StudentsDashboardArch = () => {
    const [data, setData] = useState({
        loading: true,
        firstName: '',
        lastName: '',
        grade: 1,
        signup:false,
    });
    let navigate = useNavigate();
    useEffect(() => {
        PostJSON(
            Apis.server + "/core/parents/account/info",
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                firstName: string,
                lastName: string,
                grade: number,
                profileComplete:0|1,
                signup:boolean,
            }) => {
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                if(d.profileComplete === 0){
                    navigate("/finish-profile",{replace:true});
                    return;
                }
                HideMainLoading();
                setData({
                    loading: false,
                    firstName: d.firstName,
                    grade: d.grade,
                    lastName: d.lastName,
                    signup: d.signup,
                });
            },
            () => {
                ShowConnectionFailed('fa');
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    }, []);
    const hr = {
        icon:null,
        name:null,
        to:null,
        count:null,
        hide:false,
        unavailableClick:void(0),
        available:true,
    };
    return (
        <>
            {
                data.loading ? null :
                    <>
                        <Header
                            panel={"parent"}
                            name={data.firstName + " " + data.lastName}
                            role={"دانش‌آموز"}
                            headerTitle={"دبستان مهارتی نهال"}
                        />
                        <Sidenav
                            panel={"admins"}
                            items={[
                                {
                                    name: "داشبورد",
                                    icon: <ThinDashboardIcon/>,
                                    to: "/students/overview",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                {
                                    name: "شهریه",
                                    icon: <ThinCreditScoreIcon/>,
                                    to: "/students/tuition",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                {
                                    name: "فروشگاه",
                                    icon: <ThinStoreIcon/>,
                                    to: "/students/store",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                {
                                    name: "حضوروغیاب",
                                    icon: <ThinAbsentIcon/>,
                                    to: "/students/attend",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                {
                                    name: "کلاس فوق برنامه",
                                    icon: <ThinEducationIcon/>,
                                    to: "/students/center",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                {
                                  name:null,
                                  icon:null,
                                  to:null,
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                {
                                    name: "اطلاعیه‌ها",
                                    icon: <ThinAdvertisingIcon/>,
                                    to: "/students/news",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                {
                                    name: "رضایت‌نامه ها",
                                    icon: <ThinConsentIcon/>,
                                    to: "/students/consents",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                {
                                    name: "مشاوره",
                                    icon: <ThinConsultIcon/>,
                                    to: "/students/consult",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                hr,
                                {
                                    name: "ثبت‌نام سال جدید",
                                    icon: <ThinTaskIcon/>,
                                    to: "/students/presignup",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                {
                                    name: "پروفایل",
                                    icon: <ThinAccountCircleIcon/>,
                                    to: "/students/profile",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                                {
                                    name: "تیکت",
                                    icon: <ThinnerSMSIcon/>,
                                    to: "/students/tickets",
                                    count:null,
                                    hide:false,
                                    unavailableClick:void(0),
                                    available:true,
                                },
                            ]}
                        />
                        <main id="main" className="large-nav">
                            <Outlet/>
                        </main>
                    </>
            }
        </>
    );
};